// extracted by mini-css-extract-plugin
export default {"bidGridSection":"JobDetails_bidGridSection__JsSxs","gridSpan":"JobDetails_gridSpan__yiNVo","bidData":"JobDetails_bidData__yL2CL"};